import type { ComponentColourPalettes } from './generateTonePalette';

/** CSS body for `#frame-colour-palette` in chamfered/sculptured (and future) SVGs. */
export function buildFrameColourPaletteCss(palettes: ComponentColourPalettes): string {
  const { frame, threshold, gasket } = palettes;
  return [
    `.tone-frame-light { stop-color:${frame.light}; }`,
    `.tone-frame-base { stop-color:${frame.base}; }`,
    `.tone-frame-highlight { stop-color:${frame.highlight}; }`,
    `.tone-frame-mid { stop-color:${frame.mid}; }`,
    `.tone-frame-shadow { stop-color:${frame.shadow}; }`,
    `.tone-frame-deep-shadow { stop-color:${frame.deepShadow}; }`,
    `.tone-chamfered-top-left-inner-bevel-shadow { stop-color:${frame.highlight}; }`,
    `.tone-chamfered-right-inner-bevel-shadow { stop-color:${frame.light}; }`,
    `.tone-chamfered-right-inner-bevel-mid { stop-color:${frame.highlight}; }`,
    `.tone-threshold-top { stop-color:${threshold.light}; }`,
    `.tone-threshold-mid { stop-color:${threshold.base}; }`,
    `.tone-threshold-bottom { stop-color:${threshold.shadow}; }`,
    `.stroke-frame-highlight { stroke:${frame.highlight}; }`,
    `.stroke-frame-soft-shadow { stroke:${frame.softShadow}; }`,
    `.stroke-frame-edge { stroke:${frame.edge}; }`,
    `.stroke-frame-mitre { stroke:${frame.mitre}; }`,
    `.stroke-frame-gasket { stroke:${gasket.stroke}; }`,
    `.fill-frame-highlight { fill:${frame.highlight}; }`,
    `.fill-frame-gasket { fill:${gasket.fill}; }`,
    `.fill-threshold-front { fill:${threshold.mid}; }`,
  ].join('\n');
}

const CDATA_BLOCK =
  /(<style\b[^>]*\bid=["']__STYLE_ID__["'][^>]*>)\s*<!\[CDATA\[[\s\S]*?\]\]>\s*(<\/style>)/i;
const PLAIN_BLOCK =
  /(<style\b[^>]*\bid=["']__STYLE_ID__["'][^>]*>)[\s\S]*?(<\/style>)/i;

/** Replace the contents of a named palette `<style>` without touching geometry. */
export function applyNamedSvgColourPalette(
  svgMarkup: string,
  styleId: string,
  cssBody: string
): string {
  const inner = `\n${cssBody}\n`;
  const escapedId = styleId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const cdata = new RegExp(CDATA_BLOCK.source.replace('__STYLE_ID__', escapedId), 'i');
  const plain = new RegExp(PLAIN_BLOCK.source.replace('__STYLE_ID__', escapedId), 'i');
  if (cdata.test(svgMarkup)) {
    return svgMarkup.replace(cdata, `$1<![CDATA[${inner}]]>$2`);
  }
  if (plain.test(svgMarkup)) {
    return svgMarkup.replace(plain, `$1${inner}$2`);
  }
  return svgMarkup;
}

/** Replace the contents of `#frame-colour-palette` without touching geometry. */
export function applySvgColourPalette(svgMarkup: string, cssBody: string): string {
  return applyNamedSvgColourPalette(svgMarkup, 'frame-colour-palette', cssBody);
}
